export default __webpack_public_path__ + "static/media/graxalta_GxD_jpg_webdesign2021_productillustrations_fresas_01.122f01bb.jpg";